import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

export const cmsCompHeadlineStyle = {
    'heading-1': dt(['heading-1']),
    'heading-2': dt(['heading-2']),
    'heading-3': dt(['heading-3', 'smMd:leading-13', 'lg:leading-15']),
    'heading-4': dt(['heading-4']),
    'heading-5': dt(['heading-5']),
    'heading-6': dt(['heading-6']),
};

export const cmsCompSubHeadlineStyle = {
    'body-1': dt(['text-normal']),
    'body-2': dt(['text-xlarge']),
};
